import {
  Directive,
  Input,
  OnInit,
  ElementRef,
  Renderer2, Optional, Host,
} from '@angular/core';
import { Router, RouterLinkWithHref } from '@angular/router';

@Directive({
  standalone: true,
  selector: '[linkRewrite]'
})
export class RouterLinkRewriteDirective implements OnInit {

  @Input() queryParams?: any;

  constructor(
    private router: Router,
    private el: ElementRef,
    private renderer: Renderer2,
    @Optional() @Host() private routerLink: RouterLinkWithHref
  ) {}

  ngOnInit(): void {
    const currentUrlTree = this.router.parseUrl(this.router.url);
    const cleanUrl =
      currentUrlTree.root.children['primary']?.segments.map(it => it.path).join('/') || '';

    const overridden = localStorage.getItem(cleanUrl);
    if (overridden) {
      try {
        const overriddenUrlTree = this.router.parseUrl(overridden);
        const path = '/' + overriddenUrlTree.root.children['primary']?.segments.map(it => it.path).join('/');
        const queryParams = overriddenUrlTree.queryParams;
        this.routerLink.routerLink = path;
        this.routerLink.queryParams = queryParams;
      } catch (e) {
        console.warn('Invalid overridden route:', overridden);
      }
    }
  }
}
